import { FC, Suspense } from 'react';
import { Link, Outlet } from 'react-router';

import { FlexRow, Image2, Loading } from '@portal/common/components';
import { InjectedMediaProps, styled, withMedia } from '@portal/common/theme';

const Container = styled('div')({
    display: 'flex',
    flexFlow: 'column',
    height: '100vh',
});

const Topbar = styled('div')(({ theme }) => ({
    display: 'flex',
    flexFlow: 'row',
    height: 70,
    padding: 15,
    background: theme.color.jetBlack,
}));

const Body = styled('div')({
    display: 'flex',
    flexFlow: 'column',
    flexGrow: 1,
    padding: 20,
    overflow: 'auto',
});

const StyledImage = styled(Image2)({
    boxSizing: 'border-box',
    height: 30,
});

const LayoutWithTopbar: FC<InjectedMediaProps> = ({ matchMedia }) => {
    const logoSrc = matchMedia({ mobile: '/img/logo-with-text.png' });

    return (
        <Container>
            <Topbar>
                <FlexRow align="center">
                    <Link to="/">
                        <StyledImage src={logoSrc} />
                    </Link>
                </FlexRow>
            </Topbar>
            <Body>
                <Suspense fallback={<Loading />}>
                    <Outlet />
                </Suspense>
            </Body>
        </Container>
    );
};

export default withMedia(LayoutWithTopbar);
